import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from '../../../services/admin';
import { CMSService } from '../../../services/cms-service';
import { Popup } from 'ng2-opd-popup';
import { Epidemimie } from 'model/modal-cms/epidemie';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-info-rembourse',
  templateUrl: './info-rembourse.component.html',
  styleUrls: ['./info-rembourse.component.scss']
})
export class InfoRembourseComponent implements OnInit {
  mode_add :number = 4;
  mode_madiv_:number = 1;
  pdfSrc: string = "assets/file/text/remboursement/Remboursement_des_frais_medicaux_et_de_lunetterie_V.pdf";
  pdfSrc2: string = "assets/file/text/remboursement/Rappel relative aux remboursements des frais médicaux.pdf";
  pdfSrc3: string = "assets/file/text/remboursement/INFORMATIONS SUR LA PRISE EN CHARGE MEDICALES DES AGENTS DE L.pdf";
  pdfSrc4: string = "assets/file/procedure/remborsement.pdf";
  @ViewChild('popup5') popup5: Popup;
  epidemimie: Epidemimie = new Epidemimie(null);
  nbr_covid19: any;
  date_covid19: Date;
  urllogoIec = environment.urllogoIec;
  statistique_actu : any;
  
  constructor( private router: Router,public adminService: AdminService, public cmsService: CMSService,) {}

  ngOnInit() {
    this.getinfoipdemie();
  }


  popupnew() {
    this.popup5.options = {    
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-danger",
      color: "#FF0000",
      showButtons: true,
      animationDuration: 2,
      header: "ALERT COVID-19",
      widthProsentage: 50,
      animation: "fadeInDown",
      confirmBtnContent: "En savoir plus",
      cancleBtnContent: "Fermer",
    }

    this.popup5.show(this.popup5.options);
    //this.getinfoipdemie();
  }

  getinfoipdemie() {
    let etat="ACTU"
    this.cmsService.getInfoEvolutionEpidemiebyetet(etat)
      .subscribe(data => {           
        this.epidemimie = data
        this.nbr_covid19 =  this.epidemimie.text_epid 
       this.date_covid19 = this.epidemimie.date_ajout 
       if(this.epidemimie.image_actu == null){
        this.statistique_actu = "alerte_corona.PNG";
        this.popupnew();         
      }else{
        this.statistique_actu = this.epidemimie.image_actu;
        this.popupnew();
      }
      },
        err => {
          console.log(err);
        })
  }
 
  voir(){    
   if(this.adminService.getLoginUseCMS() == "com_daf"){
       this.router.navigate(['iec-epidemie']);
    }else{
     
       this.router.navigate(['landing']);
    }
  }


  open(){
    this.mode_add = 1;
     this.mode_madiv_ = 2;
   }
 
   open2(){
     this.mode_add = 2;
      this.mode_madiv_ = 2;
    }

    open3(){
      this.mode_add = 3;
       this.mode_madiv_ = 2;
     }

     open4(){
      this.mode_add = 4;
      this.mode_madiv_ = 1;
     }
}
